// Static engineering data (services, industries, portfolio, process)
// Copy is language-neutral for identifiers; localized strings live in translations.js.

export const SERVICES = [
  { id: "mechanical-design", image: "https://images.unsplash.com/photo-1608126842524-7e10c3b18453" },
  { id: "cad-3d-modeling", image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc" },
  { id: "industrial-machinery", image: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b" },
  { id: "sheet-metal", image: "https://images.unsplash.com/photo-1608126842524-7e10c3b18453" },
  { id: "welded-structures", image: "https://images.unsplash.com/photo-1608126842524-7e10c3b18453" },
  { id: "technical-drawings", image: "https://images.pexels.com/photos/6615086/pexels-photo-6615086.jpeg" },
  { id: "reverse-engineering", image: "https://images.unsplash.com/photo-1524514587686-e2909d726e9b" },
  { id: "product-development", image: "https://images.pexels.com/photos/3861938/pexels-photo-3861938.jpeg" },
  { id: "equipment-improvements", image: "https://images.pexels.com/photos/8865187/pexels-photo-8865187.jpeg" },
  { id: "external-support", image: "https://images.unsplash.com/photo-1721244654392-9c912a6eb236" },
];

export const INDUSTRIES = [
  { id: "industrial-machinery", image: "https://images.pexels.com/photos/8865187/pexels-photo-8865187.jpeg" },
  { id: "automation", image: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b" },
  { id: "manufacturing", image: "https://images.unsplash.com/photo-1608126842524-7e10c3b18453" },
  { id: "metal-fabrication", image: "https://images.unsplash.com/photo-1524514587686-e2909d726e9b" },
  { id: "product-development", image: "https://images.pexels.com/photos/3861938/pexels-photo-3861938.jpeg" },
  { id: "special-equipment", image: "https://images.unsplash.com/photo-1721244654392-9c912a6eb236" },
];

export const PROJECTS = [
  {
    id: "p01",
    category: "machinery",
    coord: "COORD: X-88 / Y-12",
    image: "https://images.pexels.com/photos/8865187/pexels-photo-8865187.jpeg",
    year: "2024",
  },
  {
    id: "p02",
    category: "components",
    coord: "COORD: X-42 / Y-77",
    image: "https://images.unsplash.com/photo-1524514587686-e2909d726e9b",
    year: "2024",
  },
  {
    id: "p03",
    category: "assemblies",
    coord: "COORD: X-19 / Y-34",
    image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc",
    year: "2023",
  },
  {
    id: "p04",
    category: "sheet-metal",
    coord: "COORD: X-61 / Y-08",
    image: "https://images.unsplash.com/photo-1608126842524-7e10c3b18453",
    year: "2024",
  },
  {
    id: "p05",
    category: "concept",
    coord: "COORD: X-55 / Y-91",
    image: "https://images.pexels.com/photos/3861938/pexels-photo-3861938.jpeg",
    year: "2025",
  },
  {
    id: "p06",
    category: "machinery",
    coord: "COORD: X-73 / Y-46",
    image: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b",
    year: "2023",
  },
];

export const PROCESS_STEPS = ["understanding", "concept", "cad", "docs", "production"];

export const CAD_STACK = ["SolidWorks", "AutoCAD", "Autodesk Inventor", "Fusion 360", "BIM / Revit"];

export const CAPABILITIES = [
  "complex-assemblies",
  "manufacturing-drawings",
  "welded-structures",
  "sheet-metal",
  "reverse-engineering",
  "prototypes",
  "product-development",
  "bim-modeling",
  "canopies-walkways",
];

export const PROJECT_CATEGORIES = [
  "all",
  "machinery",
  "components",
  "assemblies",
  "sheet-metal",
  "concept",
];
